export default "__VITE_PUBLIC_ASSET__2952f4ea__"